import {
  IChoiceGroupStyles,
  IDropdownStyles,
  IPanelStyles,
  IStackStyles,
  ITextFieldStyles,
  ITextStyles
} from '@fluentui/react';

export const panelActionDetailsStyles: Partial<IPanelStyles> = {
  main: { overflow: 'hidden' },
  root: { marginTop: '50px' },
  navigation: { height: 'auto' }
};

export const stackActionPanelNavigationContainerStyles: Partial<IStackStyles> = {
  root: { width: '100%', alignItems: 'center', padding: '14px 10px 28px 24px' }
};

export const textActionPanelNavigationHeaderStyles: Partial<ITextStyles> = {
  root: { fontSize: '20px', fontWeight: '600' }
};

export const textFieldActionNameStyles: Partial<ITextFieldStyles> = {
  fieldGroup: { width: '320px', borderRadius: '2px', marginBottom: '24px' }
};

export const dropdownSubjectTypeStyles: Partial<IDropdownStyles> = {
  root: { width: '320px', marginBottom: '24px' }
};

export const dropdownTitleIdStyles: Partial<IDropdownStyles> = {
  root: { width: '320px', marginBottom: '24px' }
};

export const stackActionPanelCloseButtonContainerStyles: Partial<IStackStyles> = { root: { height: '32px' } };

export const textFieldParameterValueStyles: Partial<ITextFieldStyles> = { root: { width: '240px ' } };

export const choiceGroupParameterValueStyles: Partial<IChoiceGroupStyles> = {
  flexContainer: { display: 'flex', height: '32px' }
};

export const stackParameterRowContainerStyles: Partial<IStackStyles> = { root: { marginBottom: '24px' } };

export const textFieldParameterNameValueStyles: Partial<ITextFieldStyles> = { root: { width: '180px' } };

export const dropdownParameterTypeContainerStyles: Partial<IDropdownStyles> = {
  root: { width: '134px', marginLeft: '20px !important', marginRight: '20px' }
};

export const stackAddParameterButtonContainerStyles: Partial<IStackStyles> = { root: { paddingTop: '16px' } };
